import type { ReactNode } from "react";
import RequireRole from "@/components/RequireRole";

/**
 * DM系ページのルートガード。
 * dmSendEnabled=true のテナントの admin/platform_admin に表示を許可する。
 * allowReplyIntakeTenant 指定ルートでは返信取込限定テナントも許可するが、
 * 未指定の送信系画面は従来どおり dmSendEnabled=true の場合だけ許可する。
 * viewerAccess 指定ルートのみ対象テナントの viewer の閲覧も許可し、
 * それ以外の URL 直接アクセスはダッシュボードへリダイレクトする。
 * (未提供機能を顧客UIに露出させないための表示ゲート。送信自体は backend の
 * schedule 時 dmSendEnabled 検査で防止済み)
 *
 * 内部実装は RequireRole + useRole（UXガード。認可の正はバックエンド）。
 * AppShell が同一 queryKey ["auth-me"] で取得済みのためキャッシュから即時解決される。
 */
export default function RequireDmEnabled({
  children,
  viewerAccess = false,
  allowReplyIntakeTenant = false,
}: {
  children: ReactNode;
  viewerAccess?: boolean;
  allowReplyIntakeTenant?: boolean;
}) {
  return (
    <RequireRole
      allow={(r) => (r.dmEnabled || (allowReplyIntakeTenant && r.dmReplyIntakeEnabled)) && (r.isAdmin || (viewerAccess && r.isViewer))}
      fallback="redirect"
    >
      {children}
    </RequireRole>
  );
}
